var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner",class:{'fade': _vm.fadeIn},style:({ height: _vm.size + 'px',
               width: _vm.size + 'px',
               'border-width': _vm.borderWidth + 'px',
               'border-color': _vm.color,
                margin: _vm.margin })})}
var staticRenderFns = []

export { render, staticRenderFns }